// @ts-nocheck
import SubscribeState from "Components/SubscribeState";
import BaoBab from "baobab";
import ReactGA from "react-ga";
import config from "Config";

ReactGA.initialize(config.google_analytics_id);

const qldBounds = [[128, -31].reverse(), [156, -8].reverse()];
/*
 * the state object for the application. Components can
 * subscribe to this state when wrapped in a
 * SubscribeState(state, propName ) component. Also only
 * parts of the state can be subscribed to via cursors:
 * SubscribeState(state.select("ui"), "ui_state" ).
 * */
const state = new BaoBab({
  ui: {
    modal_open: true,
    search_open: "", // one of "primary", "secondary", "", null or undefined :)
    community_search_input: "",
    geo_aggregation_search_input: "",
    secondary_search_division: "" // one of "sed", "lga"
  },
  domain_data: {
    year: "2021",
    community: "Ancestry",
    community_value: "",
    geo_aggregation: "ste",
    geo_aggregation_value: ""
  },
  map_data: {
    boundaries: qldBounds,
    tooltip: {}
  }
});

state.bind_set = path =>
  state.select(path).chain(cursor => cursor.set.bind(cursor));

state.on(
  "update",
  event => event.target.get() //.log(" new state object ")
);

// Google Analytics reporting
state.select(["domain_data"]).on("update", e => {
  try {
    let changedProps = [
      "year",
      "community",
      "community_value",
      "geo_aggregation",
      "geo_aggregation_value"
    ].filter(
      prop =>
        e.data.currentData[prop] !== e.data.previousData[prop] &&
        /(\w+)_value/.test(prop)
    );

    if (changedProps.length) {
      let labelKey = changedProps[0].match(/(\w+)_value$/)[1];
      let valKey = changedProps[0];
      // changedProps.reduce((previous, current) => {});
      ReactGA.event({
        category: "Search",
        label: `${labelKey}:${e.data.currentData[valKey]}`,
        action: JSON.stringify(e.data.currentData)
      });
    }
  } catch (e) {
    ReactGA.event({
      category: "Error",
      label: "GA Event",
      action: e.message
    });
  }
});

/*
 * a Higher Order Component subscribing to updates of
 * state and rerendering all of the components wrapped
 * with it with the new state tree as the "tree" propertiy.
 * */
const withStateTree = SubscribeState(state);

module.exports = { state, withStateTree };



// WEBPACK FOOTER //
// ./state.js